const styles = theme => ({
  grid: {
    width: '100%',
    //maxWidth: 610,
    flexBasis: 'unset',
    textAlign: 'center',
    paddingTop: '1rem',
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
    maxWidth: '752px',
  },
})

export default styles
